<script lang="ts">
    import SearchHeaderInLayout from '$components/SearchHeader/SearchHeaderInLayout.svelte';
    import {
        createForm,
        type SearchHeaderFormData,
    } from '$components/SearchHeader/SearchHeaderFormData';

    export let initialValues: Partial<SearchHeaderFormData> = {};

    const [searchForm, searchFields] = createForm('search-header-form', initialValues);
</script>

<SearchHeaderInLayout
    form={searchForm}
    fields={searchFields}
    forceIsSubmitting={null}
    searchHeaderData={null}
/>
